/**
 * Module: Popup open/close behaviour and triggers.
 */
;(() => {
  const resetSession = (overlay) => {
    const sessionEnabled = overlay.dataset.sessionEnabled === "1";
    const sessionHours = parseInt(overlay.dataset.sessionHours || "0", 10);
    const popupId = overlay.dataset.popupId;
    const sessionKey = overlay.dataset.sessionKey || `pp_seen_${popupId}`;
    if (sessionEnabled && sessionHours > 0 && popupId && window.PopuppulseCookies) {
      window.PopuppulseCookies.set(sessionKey, "1", sessionHours);
    }
  };

  const openPopup = (overlay, options = {}) => {
    overlay.classList.add("is-open");
    const shouldReset = options.resetSession !== false;
    if (shouldReset) {
      resetSession(overlay);
    }
  };

  const initPopup = (overlay) => {
    const closeButtons = overlay.querySelectorAll("[data-pp-close]");
    closeButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        overlay.classList.remove("is-open");
      });
    });

    overlay.addEventListener("click", (event) => {
      if (event.target === overlay) {
        overlay.classList.remove("is-open");
      }
    });

    const openTrigger = overlay.dataset.openTrigger || "page_load";
    const sessionEnabled = overlay.dataset.sessionEnabled === "1";
    const popupId = overlay.dataset.popupId;
    const sessionKey = overlay.dataset.sessionKey || `pp_seen_${popupId}`;
    if (sessionEnabled && popupId && window.PopuppulseCookies?.get(sessionKey)) {
      return;
    }

    if (
      overlay.dataset.autoOpen === "1" &&
      (openTrigger === "page_load" || openTrigger === "page_load_and_manual")
    ) {
      const delay = parseInt(overlay.dataset.openDelay || "0", 10);
      window.setTimeout(() => openPopup(overlay), delay);
    }
  };

  const initAll = () => {
    document.querySelectorAll(".pp-overlay").forEach(initPopup);

    document.querySelectorAll("[data-pp-open]").forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        const targetId = trigger.dataset.ppOpen;
        const overlay = document.querySelector(
          `.pp-overlay[data-popup-id="${targetId}"]`
        );
        if (overlay) {
          // Manual trigger should always refresh the session window.
          openPopup(overlay, { resetSession: true });
        }
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();

